import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Input, Row, Spin } from 'antd';
import { SectionLabel, SuggestedLabel, WorkStationButton } from '../styles';
import { useWorkStationSelector } from '../hooks/useWorkStationSelector';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';

const WorkStationSelector = ({ idHeadquarter, selectedWorkStation, onSelect, suggestedIdWorkStation }) => {
  const { translate: t } = useDictionaryTranslation();
  const { workStations, isLoading } = useWorkStationSelector({ idHeadquarter });
  const [searchQuery, setSearchQuery] = useState('');

  const filteredWorkStations = useMemo(() => {
    if (!searchQuery?.trim?.().length) {
      return workStations;
    }
    return workStations.filter((workStation) =>
      workStation.name.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  }, [searchQuery, workStations]);

  return (
    <>
      <SectionLabel>{t('checkinSelectWorkStation')}</SectionLabel>
      <Input
        placeholder={t('checkinSearchWorkStationPlaceholder')}
        value={searchQuery}
        onChange={(event) => setSearchQuery(event.target.value)}
        style={{ marginBottom: 12 }}
      />
      <Spin spinning={isLoading}>
        <Row gutter={[8, 8]}>
          {filteredWorkStations.map((workStation) => {
            const isSuggested = suggestedIdWorkStation != null && workStation._id === suggestedIdWorkStation;
            const isSelected = selectedWorkStation != null && selectedWorkStation._id === workStation._id;
            return (
              <Col key={workStation._id} span={6} style={{ position: 'relative' }}>
                {isSuggested ? (
                  <SuggestedLabel>{t('checkinSuggested')}</SuggestedLabel>
                ) : null}
                <WorkStationButton
                  block
                  $selected={isSelected}
                  onClick={() => onSelect(workStation)}
                >
                  {workStation.name}
                </WorkStationButton>
              </Col>
            );
          })}
        </Row>
      </Spin>
    </>
  );
};

WorkStationSelector.propTypes = {
  idHeadquarter: PropTypes.string,
  selectedWorkStation: PropTypes.shape({ _id: PropTypes.string }),
  onSelect: PropTypes.func,
  suggestedIdWorkStation: PropTypes.string,
};

export { WorkStationSelector };
